import { Permission } from 'app/core/auth/permissions.enum';

/**
 * Platform administrator (AIVA-2143): holds the cross-tenant account admin
 * permission AND is signed in at partner level (accountUID === subAccountUID).
 * Mirrors ai-engine's check (the `_any` permission + MULTITENANT tenant scope);
 * the API stays the authority — this only decides what the UI shows.
 *
 * When the verify response has not arrived yet the tenant check is skipped, so
 * a real admin is not hidden during start-up; the API still refuses others.
 */
export function isPlatformAdminUser(
  permissions: string[],
  tenant?: { accountUID?: string; subAccountUID?: string } | null
): boolean {
  if (!permissions?.includes(Permission.ACCOUNT_ADMIN_ANY)) {
    return false;
  }
  if (!tenant?.accountUID) {
    return true;
  }
  return tenant.accountUID === tenant.subAccountUID;
}
